module.exports = __webpack_public_path__ + "img/mem_coupon_font.d6d5b08c.jpg";